<template>
  <bean-nav-layout
    :menus="menusHasPermission"
    :item-is-active="handleMenuItemIsActive"
    :show-back="showBackButton"
    @back="$router.go(-1)"
    v-if="user.id"
  >
    <template #logo>
      <div class="admin-logo">
        <img :src="require('@/assets/logo.png')" />
      </div>
    </template>
    <template #header-title>
      {{ title }}
      <portal-target name="layout-nav-title"></portal-target>
    </template>
    <template #header-content>
      <!-- <bean-lang-switcher /> -->
      <!-- <el-select v-if="roleOptions && roleOptions.length" :value="currentRoleId" @change="syncChange" class="role-select" :placeholder="choiceRole"> -->
        <!-- <el-option -->
          <!-- v-for="item in roleOptions" -->
          <!-- :key="item.value" -->
          <!-- :label="item.label" -->
          <!-- :value="item.value" -->
        <!-- /> -->
      <!-- </el-select > -->
      <el-dropdown @command="handleCommand">
        <el-button style="border: unset; color: black;"><i class="iconfont icon-menu"></i></el-button>
        <el-dropdown-menu class="nav-dropdown-menu" slot="dropdown">
          <el-dropdown-item command="handleShowProifile">{{ profile }}</el-dropdown-item>
          <el-dropdown-item command="handleLogout">{{ logout }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </bean-nav-layout>
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import _ from 'lodash';
  import { abilityService } from 'beans-admin-plugin';
  import { TOKEN_STORAGE_KEY } from '@/constants';

  @Component
  export default class LayoutNav extends Vue {
    @Prop({ type: Array, default: () => [] }) menus;

    user = {};
    roleOptions = [];
    currentRoleId = +localStorage.getItem('currentRoleId');

    get title() {
      return _.get(this.$route, 'meta.title');
    }

    get profile() {
      return this.$t('profile')
    }

    get logout() {
      return this.$t('logout')
    }

    get choiceRole() {
      return this.$t('choiceRole')
    }

    get isSuperRole() {
      return _.get(this.user, 'current_role.role.kind') === 'super';
    }

    get showBackButton() {
      if (this.$route.name) {
        const routeArr = this.$route.name.split('.');
        return _.get(this.$route, 'meta.backBtn') !== false && routeArr.length > 1 && routeArr.pop() !== 'index';
      }
      return false;
    }

    get menusHasPermission() {
      const router = this.$router;
      function mapMenu(arr) {
        return arr.map(item => {
          if (item.children && item.children.length) {
            return {
              ...item,
              children: mapMenu(item.children)
            };
          }
          const { route } = router.resolve(item.route);
          const [subject] = route.name.split('.');
          const can = item.can || `${subject}.read`;
          return {
            ...item,
            can: can ? abilityService.can(can) : abilityService.routeNameCan(route.name)
          }
        });
      }
      function filterMenu(arr) {
        return arr.filter(item => {
          if (item.children && item.children.length) {
            item.children = filterMenu(item.children);
            return item.children.length;
          }
          return item.can;
        });
      }
      const menus = filterMenu(mapMenu(this.menus));
      return menus;
    }

    async mounted() {
      const [user, { abilities }] = await Promise.all([
        this.$request.get('/mine'),
        this.$request.get('/admin_users/abilities')
      ]);
      abilityService.rules = abilities;
      this.$root.user = user;
      this.user = user;
      if (this.$route.meta.auth !== false) {
        const data = await this.$request.get('/mine/admin_users_roles');
        this.roleOptions = data.map(({ id, role, application }) => ({ value: id, label: `${role.name}${_.get(application, 'name') ? `(${application.name})` : ''}` }));
        this.currentRoleId = this.currentRoleId || (this.roleOptions.length ? this.roleOptions[0].value : null)
      }
    }

    handleCommand(command) {
      if (command === 'handleLogout') {
        this.handleLogout();
      } else if (command === 'handleShowProifile') {
        this.$router.push({ name: 'profile.show' })
      }
    }

    handleLogout() {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      this.$router.replace({ name: 'login' });
      localStorage.removeItem('currentRoleId');
    }

    handleMenuItemIsActive(menuItem) {
      const currentPath = this.$router.resolve(this.$route).resolved.path.split('/').filter(Boolean);
      const itemPath = this.$router.resolve(menuItem.route).resolved.path.split('/').filter(Boolean);
      return !!currentPath.find(item => itemPath.includes(item));
    }

    syncChange(value) {
      this.currentRoleId = value;
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
      location.reload();
    }

    @Watch('currentRoleId', { immediate: true })
    currentRoleIdChange(value) {
      if (value) {
        localStorage.setItem('currentRoleId', value);
      } else {
        localStorage.removeItem('currentRoleId');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .admin-logo {
    font-size: 24px;
    margin: 20px 0 10px;
    font-weight: bold;
    display: flex;
  }

  /deep/ .role-select {
    .el-input {
      input {
        border: 0;
        width: auto;
      }
    }
  }

  .current-user {
    margin: 0 20px 0 0;
    font-weight: bold;

    .el-button {
      font-weight: inherit;
    }
  }

  .nav-dropdown-menu {
    a, button {
      color: black;
    }
  }
</style>
